import Paginator from "../../../components/Paginator";
import {useDispatch, useSelector} from "react-redux";
import {updateDynamicItemsPageNumber} from "../../../redux/slices/dynamicUiSlice";

export default function DynamicItemsPaginator({}) {
  const activeTab = useSelector((state) => state.dynamicUi.items.activeTab);
  const selectedTab = useSelector((state) => state.dynamicUi.items[activeTab].selected);
  const {page, total} = useSelector((state) => state.dynamicUi.items[activeTab][selectedTab].meta);
  const dispatch = useDispatch();

  const onPagesClick = (page) => {
    dispatch(updateDynamicItemsPageNumber({page}));
  };


  return (
    <Paginator currentPage={page} totalPages={total} onClick={onPagesClick} loading={total === -1}/>
  );
}

